// filepath: /c:/Users/joanr/Desktop/pagina web de blog para adsense/mi-app/src/blog/BlogList.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import './BlogList.css';

const BlogList = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'posts'));
        const postsData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setPosts(postsData);
      } catch (error) {
        console.error('Error fetching posts: ', error);
      }
    };

    fetchPosts();
  }, []);

  return (
    <div className="bloglist-container">
      <h1 className="bloglist-title">Blog</h1>
      <Link to="/new-post" className="newpost-button">Crear Nuevo Artículo</Link>
      <ul className="bloglist">
        {posts.map(post => (
          <li key={post.id} className="bloglist-item">
            <Link to={`/blog/${post.slug}`} className="bloglist-link">
              {post.imageUrl && <img src={post.imageUrl} alt={post.title} className="bloglist-item-image" />}
              <h2 className="bloglist-item-title">{post.title}</h2>
              <p className="bloglist-item-excerpt">{post.content.substring(0, 100)}...</p>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BlogList;